import { createAsyncThunk } from "@reduxjs/toolkit";
import { getTrialBalanceApi } from "../../../apiservice/reports";

export const fetchTrialBalance = createAsyncThunk(
  "trialBalance/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const payload = {
        selectedFilterType: filters?.filterType,
        type: "head_total",
      };
      if (filters?.filterType === "Date Wise") {
        // payload.fromDate = filters?.fromDate;
        payload.fromDate = null;
        payload.toDate = filters?.toDate;
      }

      const res = await getTrialBalanceApi(payload);
      return res?.data ?? {};
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
